import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const updateFundingRequest = createAsyncThunk<void, UpdateFundingRequestBody, { extra: Partial<Dependencies> }>(
  "fundingRequests/updateFundingRequest",
  async (body: UpdateFundingRequestBody, { extra: { adminRepository } }) => {
    return adminRepository!.updateFundingRequest(body);
  },
);

export const resetUpdateFundingRequest = createAction("fundingRequests/resetUpdateFundingRequest");
